<template>
  <SoNavigationDrawer :links="links"></SoNavigationDrawer>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoNavigationDrawer from "@/components/navigation/SoNavigationDrawer.vue"

  export default defineComponent({
    components: {
      SoNavigationDrawer,
    },
    computed: {
      links() {
        const serviceName = this.$route.params.serviceName
        return [
          {
            icon: "list",
            title: "Jobs",
            to: `/admin/services/${serviceName}/jobs`,
          },
          {
            icon: "clipboard-check",
            title: "Warrants",
            to: `/admin/services/${serviceName}/warrants`,
          },
          {
            icon: "cog",
            title: "Configurations",
            to: `/admin/services/${serviceName}/configurations`,
          },
        ]
      },
    },
  })
</script>
